module.exports = __webpack_public_path__ + "static/media/13.microsoft-azure.e8a47ca8.svg";